import { useQuery } from "@tanstack/react-query";
import type { PartnerGoal } from "@colab/shared";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// GET /api/admin/goals?includeArchived=1 — admin board of goal templates.
export function useGoals(opts: { includeArchived?: boolean } = {}) {
  const qs = opts.includeArchived ? "?includeArchived=1" : "";
  return useQuery<PartnerGoal[], ApiClientError>({
    queryKey: opts.includeArchived
      ? ([...queryKeys.goals.list(), "with-archived"] as const)
      : queryKeys.goals.list(),
    queryFn: () => apiFetch<PartnerGoal[]>(`/admin/goals${qs}`),
  });
}
